import { BRAND } from "@/data/content";

export const LEGAL = [
  {
    key: "privacy",
    title: "Privacy Policy",
    body: [
      `${BRAND.name} respects your privacy. This policy explains how we collect, use and protect the information you share with us.`,
      "Information we collect: Your name, email, phone number, claim type and any case details you voluntarily submit through our contact form or during consultation.",
      "How we use it: Solely to assess and assist with your insurance claim, to contact you regarding your enquiry, and to improve our services. We do not sell your data to third parties.",
      "Data security: Submissions are stored securely and access is restricted to authorised advisors handling your case.",
      "Your rights: You may request access to, correction of, or deletion of your personal data at any time by writing to " + BRAND.email + ".",
    ],
  },
  {
    key: "terms",
    title: "Terms & Conditions",
    body: [
      `By using this website and engaging ${BRAND.name}, you agree to the following terms.`,
      "Nature of service: We are an independent insurance claim advisory. We are not an insurer, and we are not affiliated with or acting on behalf of any insurance company.",
      "No guarantee: While we work diligently to achieve the best possible outcome, we do not and cannot guarantee the approval or recovery of any claim, as outcomes depend on policy terms, evidence and the insurer's decision.",
      "Fees: The initial claim review is free. A flat ₹999 Case Assessment & Strategy Fee applies if you choose to proceed. A 20% Success Fee + GST is charged only on successful claim recovery, wherever applicable.",
      "Client responsibilities: You agree to provide accurate, complete and truthful information and documents relating to your claim.",
    ],
  },
  {
    key: "disclaimer",
    title: "Disclaimer",
    body: [
      `${BRAND.name} provides claim advisory and resolution assistance on an independent basis.`,
      "The information on this website is for general informational purposes only and does not constitute legal or financial advice.",
      "We are not an insurance company, agent, broker or a substitute for the insurer's official grievance process. Any statistics shown are indicative of our assistance experience.",
      "Final decisions on any insurance claim rest solely with the concerned insurer, ombudsman or judicial authority.",
    ],
  },
  {
    key: "refund",
    title: "Refund Policy",
    body: [
      "The initial claim review is free of charge.",
      "The ₹999 Case Assessment & Strategy Fee covers the professional time and analysis invested in evaluating and strategising your case, and is therefore non-refundable once the assessment has commenced.",
      "The 20% Success Fee + GST is charged only after successful claim recovery; if no recovery is achieved, no success fee is payable.",
      "For any billing questions, please contact us at " + BRAND.email + ".",
    ],
  },
];
